import { vehicleTypes } from './VehicleType';

export const mainCategoryParams = [...vehicleTypes] as const;

export type MainCategory = (typeof mainCategoryParams)[number];
